<template>
  <div class="empadronamiento__intro__main__form__container-item" :class="isMobile() && ((date == null || date == '' || date =='Invalid date')) ? '' : 'fieldFocused'">
    <label>{{label}}</label>
    <input
      class="empadronamiento__intro__main__form__container-form"
      :class="{'has-error': invalid}"
      type="date"
      :min="minDateLimit"
      :max="maxDateLimit"
      v-model="date"
      @input="formatDate"
      @focus="focused = true"
      @blur="focused = false"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      date: "",
      focused: false
    };
  },
  computed: {
    minDateLimit() {
      if(this.minDate)
      {
        return moment(this.minDate,'DD/MM/YYYY').format('YYYY-MM-DD')
      }
      return ''
    },
    maxDateLimit() {
      if(this.maxDate)
      {
        return moment(this.maxDate,'DD/MM/YYYY').format('YYYY-MM-DD')
      }
      return ''
    }
  },
  props: {
    value: String,
    invalid: Boolean,
    label: String,
    minDate : String,
    maxDate : String
  },
  methods: {
    formatDate(ev) {
      const date = ev.target.value;
      if (date === '' ) {
        this.$emit("input", '');
      } else {
        this.$emit("input", moment(date).format("DD/MM/YYYY"));
      }
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.date = moment(this.value, 'DD-MM-YYYY').format('YYYY-MM-DD');
  },
  watch: {
    value() {
      this.date = moment(this.value, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
  }
};
</script>